module.exports = __webpack_public_path__ + "static/media/bm-geologia.7bf1a576.png";